import EE from '~/listenerEventService/EventEmitter';
import { clickstreamLogger } from '~/logging';

export default class ScreenListener extends EE implements IListener {
  onResize = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    clickstreamLogger.debug(`New screen size (${width}, ${height})`);

    this.emit('analytics', {
      type: 'screen-size',
      width,
      height,
    });
  }

  start() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  stop() {
    window.removeEventListener('resize', this.onResize);
  }
}
